// Wrapper sobre lucide-react que mantiene la API antigua (`name` en kebab-case + `size`).
// Centraliza el mapping para que renombrar un icono o cambiar lib se haga en un único punto.

import {
  BarChart3,
  Book,
  BookOpenText,
  Calendar,
  Check,
  Home,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  LogOut,
  Mail,
  Menu,
  NotebookPen,
  Plus,
  Star,
  Trash2,
  User,
  Users,
  Video,
  X,
  type LucideIcon,
  type LucideProps,
} from 'lucide-react';

const ICONS = {
  'bar-chart':    BarChart3,
  book:           Book,
  'book-open-text': BookOpenText,
  calendar:       Calendar,
  check:          Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up':   ChevronUp,
  clock:          Clock,
  home:           Home,
  'log-out':      LogOut,
  mail:           Mail,
  menu:           Menu,
  'notebook-pen': NotebookPen,
  plus:           Plus,
  star:           Star,
  trash:          Trash2,
  user:           User,
  users:          Users,
  video:          Video,
  x:              X,
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS;

interface IconProps extends Omit<LucideProps, 'ref'> {
  name: IconName;
  size?: number | string;
}

export function Icon({ name, size = 18, ...props }: IconProps) {
  const Comp = ICONS[name];
  return <Comp size={size} strokeWidth={2} aria-hidden="true" {...props} />;
}
